module.exports = __webpack_public_path__ + "static/img/member_vip_bg_n.cb16237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member_vip_bg_n.png
// module id = cLvn
// module chunks = 1